import * as Constants from '../constants/product';

export const updateProduct = ($http, ENV, productId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_PRODUCT_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/products/${productId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_PRODUCT_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_PRODUCT_FAILED, payload: error });
        reject(error);
      });
  });

export const getProduct = ($http, ENV, productId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PRODUCT_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/products/${productId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_PRODUCT_SUCCESS,
          payload: res.data['products'],
        });
        resolve(res.data['products']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PRODUCT_FAILED, payload: error });
        reject(error);
      });
  });

export const setProduct = (data) => (dispatch) =>
  dispatch({ type: Constants.SET_PRODUCT, payload: data });
